export default __webpack_public_path__ + "static/media/ContactLightT.c9cd9604.svg";